export default "__VITE_ASSET__Bd0c3NQE__"